"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertBaseUnitsToDisplayUnits = convertBaseUnitsToDisplayUnits;
exports.convertBaseUnitsToDollarValue = convertBaseUnitsToDollarValue;
exports.convertCoinGeckoPricesToDenomPriceMap = convertCoinGeckoPricesToDenomPriceMap;
exports.convertDollarValueToDenomUnits = convertDollarValueToDenomUnits;
exports.getAssetByDenom = getAssetByDenom;
exports.getChainDenomBySymbol = getChainDenomBySymbol;
exports.getCoinGeckoIdByDenom = getCoinGeckoIdByDenom;
exports.getDenomByCoinGeckoId = getDenomByCoinGeckoId;
exports.getExponentByDenom = getExponentByDenom;
exports.getSymbolByChainDenom = getSymbolByChainDenom;
exports.noDecimals = noDecimals;
var _bignumber = _interopRequireDefault(require("bignumber.js"));
function getAssetByKeyValue(assets, key, value, chainName) {
  var filteredAssets = assets.filter(function (_ref) {
    var chain_name = _ref.chain_name;
    return !chainName || chain_name === chainName;
  }).flatMap(function (_ref2) {
    var assets = _ref2.assets;
    return assets;
  });
  var matchingAssets = filteredAssets.filter(function (asset) {
    return asset[key] === value;
  });
  if (matchingAssets.length === 0) {
    throw new Error("No asset found for ".concat(key, " '").concat(value, "'"));
  }
  if (matchingAssets.length > 1) {
    throw new Error("Ambiguity: ".concat(matchingAssets.length, " assets found for ").concat(key, " '").concat(value, "'"));
  }
  return matchingAssets[0];
}
function getAssetByDenom(assets, denom, chainName) {
  return getAssetByKeyValue(assets, 'base', denom, chainName);
}
function getDenomByCoinGeckoId(assets, coinGeckoId, chainName) {
  return getAssetByKeyValue(assets, 'coingecko_id', coinGeckoId, chainName).base;
}
function getCoinGeckoIdByDenom(assets, denom) {
  var _asset$coingecko_id;
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    chainName = _ref3.chainName,
    _ref3$allowTestnet = _ref3.allowTestnet,
    allowTestnet = _ref3$allowTestnet === void 0 ? false : _ref3$allowTestnet,
    _ref3$customAssetFilt = _ref3.customAssetFilter,
    customAssetFilter = _ref3$customAssetFilt === void 0 ? function () {
      return true;
    } : _ref3$customAssetFilt,
    _ref3$excludedChainNa = _ref3.excludedChainNames,
    excludedChainNames = _ref3$excludedChainNa === void 0 ? [] : _ref3$excludedChainNa;
  var filteredAssetLists = assets.filter(function (_ref4) {
    var chain_name = _ref4.chain_name;
    return (!chainName || chain_name === chainName) && (allowTestnet || !chain_name.includes('testnet')) && !excludedChainNames.includes(chain_name);
  });
  var filteredAssets = filteredAssetLists.flatMap(function (_ref5) {
    var assets = _ref5.assets;
    return assets;
  }).filter(function (_ref6) {
    var coingecko_id = _ref6.coingecko_id;
    return coingecko_id;
  }).filter(customAssetFilter);
  var asset = filteredAssets.find(function (_ref7) {
    var base = _ref7.base;
    return base === denom;
  });
  return (_asset$coingecko_id = asset === null || asset === void 0 ? void 0 : asset.coingecko_id) !== null && _asset$coingecko_id !== void 0 ? _asset$coingecko_id : null;
}
function getSymbolByChainDenom(assets, denom, chainName) {
  return getAssetByDenom(assets, denom, chainName).symbol;
}
function getChainDenomBySymbol(assets, symbol, chainName) {
  return getAssetByKeyValue(assets, 'symbol', symbol, chainName).base;
}
function getExponentByDenom(assets, denom, chainName) {
  var _unit$exponent;
  var asset = getAssetByDenom(assets, denom, chainName);
  var unit = asset.denom_units.find(function (_ref8) {
    var denom = _ref8.denom;
    return denom === asset.display;
  });
  return (_unit$exponent = unit === null || unit === void 0 ? void 0 : unit.exponent) !== null && _unit$exponent !== void 0 ? _unit$exponent : 0;
}
function convertCoinGeckoPricesToDenomPriceMap(assets, prices) {
  return Object.keys(prices).reduce(function (res, geckoId) {
    var denom = getDenomByCoinGeckoId(assets, geckoId);
    res[denom] = prices[geckoId].usd;
    return res;
  }, {});
}
function noDecimals(num) {
  return new _bignumber["default"](num).decimalPlaces(0, _bignumber["default"].ROUND_DOWN).toString();
}
function convertBaseUnitsToDollarValue(assets, prices, symbol, amount, chainName) {
  var denom = getChainDenomBySymbol(assets, symbol, chainName);
  return new _bignumber["default"](amount).shiftedBy(-getExponentByDenom(assets, denom, chainName)).multipliedBy(prices[denom]).toString();
}
function convertDollarValueToDenomUnits(assets, prices, symbol, value, chainName) {
  var denom = getChainDenomBySymbol(assets, symbol, chainName);
  return new _bignumber["default"](value).dividedBy(prices[denom]).shiftedBy(getExponentByDenom(assets, denom, chainName)).toString();
}
function convertBaseUnitsToDisplayUnits(assets, symbol, amount, chainName) {
  var denom = getChainDenomBySymbol(assets, symbol, chainName);
  return new _bignumber["default"](amount).shiftedBy(-getExponentByDenom(assets, denom, chainName)).toString();
}